import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PokemonItems from './PokemonItems';

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<PokemonItems />}/>
      </Routes>
    </BrowserRouter>
  )
}

export default Router;